<template>
  <!-- 灰度配置 -->
  <el-dialog
    :title="$t('button.grayscaleConfig')"
    :visible.sync="dialogVisible"
    width="650px"
    :before-close="handleClose"
    :close-on-click-modal="false"
  >
    <div class="from-content">
      <el-form
        :model="params"
        :rules="rules"
        ref="ruleForm"
        label-width="auto"
        class="demo-ruleForm"
      >
        <el-tabs v-model="activeName">
          <el-tab-pane :label="$t('pages.equipment.text236')" name="first">
            <el-form-item
              :label="$t('pages.equipment.text5')"
              prop="bikeCategoryId"
            >
              <el-select
                v-model="params.bikeCategoryId"
                :placeholder="$t('public.text5')"
                @change="bikeCategoryIdChange"
              >
                <el-option
                  v-for="item in bikeCategoryIdList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              :label="$t('pages.equipment.text6')"
              prop="bikeTypeId"
            >
              <el-select
                v-model="params.bikeTypeId"
                :placeholder="$t('public.text5')"
              >
                <el-option
                  v-for="item in bikeTypeIdList"
                  :key="item.id"
                  :label="item.bikeTypeName"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item :label="$t('pages.equipment.text198')" prop="hwType">
              <el-select
                v-model="params.hwType"
                :placeholder="$t('public.text5')"
                @change="hwTypeChange"
              >
                <el-option
                  v-for="item in hwTypeList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              :label="$t('pages.equipment.text199')"
              prop="hwVersion"
            >
              <el-select
                v-model="params.hwVersion"
                :placeholder="$t('public.text5')"
                @change="hwVersionChange"
              >
                <el-option
                  v-for="item in firmwareManagementList"
                  :key="item.id"
                  :label="item.hwVersion"
                  :value="item.hwVersion"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              :label="$t('pages.equipment.text201')"
              prop="fwVersion"
            >
              <el-select
                v-model="params.fwVersion"
                :placeholder="$t('public.text5')"
                @change="changeFirmwareSize"
              >
                <el-option
                  v-for="(item, index) in listAllFwVersionList"
                  :key="index"
                  :label="item.fwVersion"
                  :value="item.fwVersion"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              :label="$t('pages.equipment.text200')"
              v-show="params.firmwareName"
            >
              <span>{{ params.firmwareName }}</span>
            </el-form-item>
            <el-form-item :label="$t('omission.text4')" v-show="fileSize">
              <span>{{ fileSize }}</span>
            </el-form-item>
          </el-tab-pane>
          <el-tab-pane :label="$t('pages.equipment.text235')" name="second">
            <div class="first-content">
              <div
                class="input"
                v-for="(item, index) in params.bikeCodes"
                :key="index"
              >
                <el-input
                  :placeholder="$t('pages.equipment.text7')"
                  maxlength="10"
                  v-model="item.value"
                ></el-input>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane :label="$t('pages.equipment.text237')" name="third">
            <el-form-item
              :label="$t('pages.equipment.text229')"
              prop="upgradeType"
            >
              <el-select
                v-model="params.upgradeType"
                :placeholder="$t('public.text5')"
              >
                <el-option :label="$t('pages.equipment.text238')" value="1">
                </el-option>
                <el-option :label="$t('pages.equipment.text239')" value="2">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              :label="$t('pages.equipment.text212')"
              prop="startValidTime"
            >
              <el-date-picker
                v-model="params.startValidTime"
                type="datetime"
                :placeholder="$t('omission.text11')"
                default-time="12:00:00"
                :picker-options="pickerOptions"
              >
              </el-date-picker>
            </el-form-item>
            <el-form-item
              :label="$t('pages.equipment.text230')"
              prop="upgradeIntro"
            >
              <el-input
                type="textarea"
                rows="4"
                v-model="params.upgradeIntro"
                maxlength="200"
              ></el-input>
            </el-form-item>
          </el-tab-pane>
        </el-tabs>
      </el-form>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">{{ $t("button.close") }}</el-button>
      <el-button type="primary" @click="submit">{{
        $t("button.determine")
      }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { mapState } from "vuex";
import { resetDate } from "../../../../utils/util/validate";
import { sizeReset } from "../../../../utils/util/validate";
export default {
  data() {
    return {
      pickerOptions: {
        shortcuts: [
          {
            text: this.$t("omission.text74"),
            onClick(picker) {
              let user = JSON.parse(localStorage.getItem("platformData"));
             
              if (user.region == "cn") {
                picker.$emit("pick", new Date());
              }
              if (user.region == "eur") {
                const date = new Date();
                date.setTime(date.getTime() - 3600 * 1000 * 7);
                picker.$emit("pick", date);
              }
              if (user.region == "usa") {
                const date = new Date();
                date.setTime(date.getTime() - 3600 * 1000 * 13);
                picker.$emit("pick", date);
              }
              if (user.region == "jp") {
                const date = new Date();
                date.setTime(date.getTime() + 3600 * 1000 * 1);
                picker.$emit("pick", date);
              }
            },
          },
        ],
      },
      fileSize: "", //固件大小
      activeName: "first",
      params: {
        belongCustomerId: "", //客户id
        bikeCodes: [
          {
            valvue: "",
          },
          {
            valvue: "",
          },
          {
            valvue: "",
          },
          {
            valvue: "",
          },
          {
            valvue: "",
          },
          {
            valvue: "",
          },
          {
            valvue: "",
          },
          {
            valvue: "",
          },
          {
            valvue: "",
          },
          {
            valvue: "",
          },
        ], //车辆编码集合
        bikeCategoryId: "", //车辆类别
        bikeTypeId: "", //车辆型号
        firmwareName: "", //固件名称
        fwVersion: "", //固件版本
        hwType: "", //固件类别
        hwVersion: "", //硬件版本
        startValidTime: "", //开始生效时间
        upgradeIntro: "", //升级说明
        upgradeType: "", //升级方式 蓝牙/4g,1蓝牙 2 4g
      },
      rules: {
        bikeCategoryId: {
          required: true,
          message: this.$t("pages.equipment.text150"),
          trigger: "change",
        },
        bikeTypeId: {
          required: true,
          message: this.$t("pages.equipment.text64"),
          trigger: "change",
        },
        hwType: {
          required: true,
          message: this.$t("pages.equipment.text220"),
          trigger: "change",
        },
        hwVersion: {
          required: true,
          message: this.$t("pages.equipment.text240"),
          trigger: "change",
        },
        fwVersion: {
          required: true,
          message: this.$t("pages.equipment.text241"),
          trigger: "change",
        },
        upgradeType: {
          required: true,
          message: this.$t("pages.equipment.text242"),
          trigger: "change",
        },
        startValidTime: {
          required: true,
          message: this.$t("pages.equipment.text243"),
          trigger: "change",
        },
        upgradeIntro: [
          {
            required: true,
            message: this.$t("pages.equipment.text244"),
            trigger: "blur",
          },
          {
            max: 200,
            message: this.$t("pages.equipment.text245"),
            trigger: "blur",
          },
        ],
      },
      bikeTypeIdList: [],
      firmwareManagementList: [],
      listAllFwVersionList: [],
      hwTypeList: [
        {
          label: this.$t("pages.equipment.text178"),
          value: 10,
        },
        {
          label: this.$t("pages.equipment.text202"),
          value: 15,
        },
        {
          label: this.$t("pages.equipment.text203"),
          value: 20,
        },
        {
          label: this.$t("pages.equipment.text204"),
          value: 25,
        },
        {
          label: this.$t("pages.equipment.text205"),
          value: 30,
        },
        {
          label: this.$t("pages.equipment.text206"),
          value: 35,
        },
        {
          label: this.$t("pages.equipment.text207"),
          value: 40,
        },
        {
          label: this.$t("pages.equipment.text208"),
          value: 45,
        },
      ],
    };
  },
  computed: {
    ...mapState(["platformData"]),
  },
  props: ["dialogVisible", "bikeCategoryIdList"],
  methods: {
    //关闭
    handleClose() {
      this.params = {
        belongCustomerId: "", //客户id
        bikeCodes: [
          {
            valvue: "",
          },
          {
            valvue: "",
          },
          {
            valvue: "",
          },
          {
            valvue: "",
          },
          {
            valvue: "",
          },
          {
            valvue: "",
          },
          {
            valvue: "",
          },
          {
            valvue: "",
          },
          {
            valvue: "",
          },
          {
            valvue: "",
          },
        ], //车辆编码集合
        bikeCategoryId: "", //车辆类别
        bikeTypeId: "", //车辆型号
        firmwareName: "", //固件名称
        hwType: "", //固件类别
        hwVersion: "", //硬件版本
        fwVersion: "", //固件版本
        startValidTime: "", //开始生效时间
        upgradeIntro: "", //升级说明
        upgradeType: "", //升级方式 蓝牙/4g,1蓝牙 2 4g
      };
      this.fileSize = ""; //固件大小
      this.activeName = "first";
      this.firmwareManagementList = [];
      this.listAllFwVersionList = [];
      this.$emit("dialogClose");
    },
    //文件大小
    sizeReset(e) {
      return sizeReset(e);
    },
    //固件名称改变
    changeFirmwareSize(e) {
      let arr = this.listAllFwVersionList;
      for (let i in arr) {
        if (e == arr[i].fwVersion) {
          this.fileSize = this.sizeReset(arr[i].fileSize);
          this.params.firmwareName = arr[i].firmwareName;
        }
      }
    },
    //车辆类别改变
    bikeCategoryIdChange() {
      this.params.bikeTypeId = null;
      this.firmwareManagementListAllBikeType();
    },
    //查询车辆型号（筛选）
    firmwareManagementListAllBikeType() {
      let str = "";
      str = "?bikeCategoryId=" + this.params.bikeCategoryId;
      this.request.firmwareManagementListAllBikeType(str).then((res) => {
        this.bikeTypeIdList = res.data;
      });
    },
    //车辆型号改变
    // bikeTypeIdChange() {},
    //固件类别改变
    hwTypeChange() {
      this.params.hwVersion = null;
      this.fileSize = null;
      this.params.firmwareName = null;
      this.listAllFwVersionList = [];
      this.params.fwVersion = null;
      this.firmwareManagementList = [];
      this.firmwareManagementListAll();
    },
    //硬件版本改变
    hwVersionChange() {
      this.params.firmwareName = null;
      this.listAllFwVersionList = [];
      this.params.fwVersion = null;
      this.listAllFwVersion();
    },
    //查询所有硬件版本
    firmwareManagementListAll() {
      let formData = {
        hwType: this.params.hwType,
      };
      this.request.listALlDistinctHwVersion(formData).then((res) => {
        this.firmwareManagementList = res.data;
      });
    },
    //查询所有固件版本
    listAllFwVersion() {
      let formData = {
        belongCustomerId: this.platformData.id,
        bikeCategoryId: this.params.bikeCategoryId,
        bikeTypeId: this.params.bikeTypeId,
        hwType: this.params.hwType,
        hwVersion: this.params.hwVersion,
      };
      this.request.listAllFwVersion(formData).then((res) => {
        this.listAllFwVersionList = res.data;
      });
    },
    //确定
    submit() {
      let arr = this.params.bikeCodes;
      let arr1 = [];
      for (let i in arr) {
        if (arr[i].value) {
          arr1.push(arr[i].value);
        }
      }
      if (arr1.length < 1) {
        return this.$message.error(this.$t("pages.equipment.text246"));
      }
      for (let i in arr1) {
        if (arr1[i].length < 5) {
          return this.$message.error(this.$t("pages.equipment.text247"));
        }
      }
      this.params.startValidTime = resetDate(this.params.startValidTime); // 开始时间
      this.params.belongCustomerId = this.platformData.id;
      let params = { ...this.params, bikeCodes: arr1 };

      this.$refs["ruleForm"].validate((valid) => {
        if (valid) {
          this.request.grayScaleTestAdd(params).then(() => {
            this.$emit("grayScaleTestList");
            this.$message({
              type: "success",
              message: this.$t("pages.equipment.text248"),
            });
            this.handleClose();
          });
        }
      });
    },
  },
};
</script>

<style scoped>
.input {
  width: 300px;
  margin-bottom: 10px;
}
.first-content {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}
</style>